import { IntercomAPI } from '@/integrations/Intercom';
import { Body, TrevorIcon, Typography } from '@trevor/ui-components';
import React from 'react';
import styled from 'styled-components';
import { userAction } from '@/util/helpers/ajax-helpers';

export const HelpChatWithUsContainer = styled(Body).attrs({
  variant: 1,
})`
  margin-bottom: 48px;

  > span {
    margin-left: var(--spacing-s);
    display: inline-flex;
    color: var(--color-interface-secondary-normal);

    > svg {
      margin-left: 5px;
    }
  }
`;

export const HelpChatWithUs = () => {
  const handleLiveSupport = () => {
    userAction('live-chat-support-clicked', {
      section: 'datasource-initial',
    });
    IntercomAPI.show();
  };

  return (
    <HelpChatWithUsContainer>
      Need help with anything?&nbsp;
      <span onClick={handleLiveSupport}>
        <Typography tag="a">Chat with us</Typography>
        <TrevorIcon name="annotate" />
      </span>
    </HelpChatWithUsContainer>
  );
};
